export default "__VITE_ASSET__3521ebe4__"